import BrandingActionButton from "./BrandingActionButton";

// Save Draft/Discard Changes live on the Draft Branding card (BrandingForm)
// — they only ever act on its two fields. Discard Draft stays here: it
// drops the whole saved draft, assets included, which is the one case
// broader than "this section only" (see BrandingForm's own "Discard Draft"
// for the text-only, assets-preserving version). Reset touches config and
// assets both, and Publish ships everything live — both are genuinely
// page-wide too.
const BrandingActionBar = ({
  disabled,
  hasDraft,
  canPublish,
  canReset = true,
  showReset = true,
  isPublishing,
  isDiscarding,
  isResetting,
  onPublish,
  onDiscard,
  onReset,
}) => {
  return (
    <div className="flex flex-wrap items-center justify-end gap-1.5">
      {/* Hidden rather than disabled: once published and draft both already
          match the IMS defaults with no custom assets, there's nothing left
          to reset — the same reasoning Discard Draft below uses for "no
          draft". */}
      {showReset && (
        <BrandingActionButton variant="destructive" onClick={onReset} disabled={disabled || !canReset} loading={isResetting} loadingText="Resetting...">
          Reset to IMS Defaults
        </BrandingActionButton>
      )}
      {/* Hidden rather than disabled: with no draft there's nothing to
          discard, and a permanently-greyed button next to every fresh page
          load read as clutter, not as an available action waiting on state. */}
      {hasDraft && (
        <BrandingActionButton variant="destructive" onClick={onDiscard} disabled={disabled} loading={isDiscarding} loadingText="Discarding...">
          Discard All Draft
        </BrandingActionButton>
      )}
      {/* Publish needs a draft that would actually change something — a
          byte-identical draft just inflates the version counter. It's the
          action that ships branding live, so it carries the strongest
          weight and sits last in reading order. */}
      <BrandingActionButton variant="default" onClick={onPublish} disabled={disabled || !canPublish} loading={isPublishing} loadingText="Publishing...">
        Publish
      </BrandingActionButton>
    </div>
  );
};

export default BrandingActionBar;
